import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Row, Col, Spin, message, Modal } from "antd";
// import Icon from '@ant-design/icons';
import { LoadingOutlined } from "@ant-design/icons";

import moment from "moment";
import liracrypt from "../../components/Liracrypt/liracrypt";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ZenModal from "../../components/ZenModal";
import noImg from '../../assets/static/noImg.jpeg';
import { createRoute } from "../../utils/CustomFunc";
import { useSelector } from "react-redux";
// import { useDispatch, useSelector } from "react-redux";
// import { Drawer, Layout, Col, Row } from "antd";

const style = { padding: "8px 0", textAlign: "center" };

const colorList = [
    "#ff9ff3",
    "#feca57",
    "#ff6b6b",
    "#f368e0",
    "#ff9f43",
    "#ee5253",
    "#00d2d3",
    "#54a0ff",
    "#5f27cd",
];

const HotLine2 = ({ selectedLid }) => {
    const [loginError, setLoginError] = useState(false);
    const urlCode = useSelector(state => state.urlCode);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }


    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (record) => {
        if (record.zenPop) {
            let zenPopDataIndex = { ...record.zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }



    const fetchHotlineData = () => {
        setLoading(true);
        liracrypt
            .get("/textapi", { dn: 'HotLine2' })
            .then(({ data }) => {
                const fetchdata = data.data ? data.data : [];
                setData(fetchdata);
                setLoading(false);
            })
            .catch(function (error) {
                // message.error('ERROR: Unable to save!', 4);
                console.log("Error****:");
                setLoading(false);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };

    const displayMessage = (val, id) => {
        setLoading(true);
        let postData = {
            _id: id,
            val,
            lid: selectedLid
        };
        liracrypt.post('/hotline/msg', postData).then(res => {

            message.success(res.data.message);
            setLoading(false);
        }).catch(err => {
            console.log("Error****:");
            setLoading(false);
            if (err.response !== undefined) {
                if (err.response.status !== 401) {
                    ApiErrorComp(err.response.status);
                } else {
                    setLoginError(true);
                }
            }
        })
        // setTimeout(() => {
        //   message.success("Message sent sucessfully");
        //   setLoading(false);
        // }, (Math.floor(Math.random() * 2) + 1) * 1000);
    };
    const getMenu = (val, index, id) => {
        return (
            <>
                <SessionError visible={loginError} />
                <Menu theme="dark">
                    {val.map((value) => (
                        <Menu.Item key={value}>
                            <Button
                                style={{
                                    marginBottom: "0",
                                    backgroundColor: colorList[index],
                                    width: "100%",
                                    color: "#fff",
                                    fontWeight: "600",
                                    borderRadius: "5px",
                                    border: "0",
                                }}
                                onClick={() => onColumnClick(value, id)}
                            >
                                {value.label}
                            </Button>
                        </Menu.Item>
                    ))}
                </Menu>
            </>
        );
    };

    useEffect(() => {
        if (data === null && loading === false) {
            fetchHotlineData();
        }
    }, [data]);
    return !loading && data ? (
        <Row gutter={[8, 8]}>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
            {data.map((rec, index) => (
                <Col className="gutter-row" span={8} key={index}>
                    <div style={style}>
                        {
                            rec.typ === 'dropDown' ?
                                <Dropdown overlay={getMenu(rec.val, index, rec._id)} trigger={["click"]}>
                                    <Button
                                        style={{
                                            marginBottom: "0",
                                            padding: "15px",
                                            width: "180px",
                                            fontSize: "18px",
                                            backgroundColor: colorList[index],
                                            height: "auto",
                                            color: "#fff",
                                            fontWeight: 600,
                                            border: 0,
                                            boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                                            borderRadius: "7px",
                                        }}
                                    >
                                        {rec._id}
                                    </Button>
                                </Dropdown> :
                                <Button
                                    style={{
                                        marginBottom: "0",
                                        padding: "15px",
                                        width: "180px",
                                        fontSize: "18px",
                                        backgroundColor: colorList[index],
                                        height: "auto",
                                        color: "#fff",
                                        fontWeight: 600,
                                        border: 0,
                                        boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                                        borderRadius: "7px",
                                    }}
                                    onClick={() => onColumnClick(rec)}
                                >
                                    {rec._id}
                                </Button>
                        }

                    </div>
                </Col>
            ))}
        </Row>
    ) : (
        <div className="Loading">
            <Spin indicator={antIcon} />
        </div>
    );
};

export default HotLine2;
